import {ModuleConfiguration} from "../router/model/UserPermission";
import {LqbPricerLogModuleName, LqbPricerParamsServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName, UtilsModuleName} from "../utils/names/requiredModulesNames";

export const LqbPricerModule = new ModuleConfiguration(LqbPricerLogModuleName,
    [
        LqbPricerLogModuleName,
        UtilsModuleName,
        LqbPricerParamsServiceModuleName,
        AngularJsMaterialModuleName
    ]
);